import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const NotFound = ({
    parent,
}: {
    parent:
        | "index"
        | "clubhouse"
        | "tournamentmanagement"
        | "tournaments"
        | "sitemanagement";
}): React.JSX.Element => {
    let errorContent: React.ReactNode;

    switch (parent) {
        case "clubhouse":
            errorContent = "Clubhouse Page Not Found";
            break;
        case "tournamentmanagement":
            errorContent = "League Management Page Not Found";
            break;
        case "tournaments":
            errorContent = "Tournament Page Not Found";
            break;
        case "sitemanagement":
            errorContent = "Site Management Page Not Found";
            break;
        default:
            errorContent = "Page Not Found";
            break;
    }

    return <h2>{errorContent}</h2>;
};

export default NotFound;
